<script>
	export let latitude, longitude;
	export let mapcontroller;

	$: {
		if (mapcontroller.is_widget_active()) {
			mapcontroller.set_user_position(latitude, longitude);
		}
	}
</script>

<div class="map-container w-full aspect-square" use:mapcontroller.widget></div>